import React from 'react';
import { withApollo } from 'react-apollo';

import {
  XYPlot,
  XAxis,
  YAxis,
  ChartLabel,
  HorizontalGridLines,
  VerticalGridLines,
  LineSeries,
  LineSeriesCanvas,
  LabelSeries,
  DiscreteColorLegend,
  LineMarkSeries,
  Hint
} from 'react-vis';


  class CallAttempts extends React.Component {
  
    constructor(props) {
      super(props);
      this.state = { 
        drawMode: 0,
        data: this.props.callDetailsData,
        value: {},
        hoveredItem: false};
      this.mouseOverCall = this.mouseOverCall.bind(this);
      this.onNearestXYCall = this.onNearestXYCall.bind(this);
      this.mouseLeaveCall = this.mouseLeaveCall.bind(this);
      // console.log("inside NtmTrace");
    }

  
  
    mouseOverCall = () => {
      // console.log('mouseOverCallBefore', this.state.value);
      this.setState({ value: false });
      // console.log('mouseOverCallAfter', this.state.value);
    }
  
    mouseLeaveCall = () => {
      // console.log('mouseLeaveCallBefore', this.state.value);
      this.setState({ value: false });
      // console.log('mouseLeaveCallAfter', this.state.value);
    }
  
    onNearestXYCall = (domain, inpValue) =>{
      // console.log('onNearestXYCallActual', domain, inpValue)
      const simpleDate= new Date(inpValue.x).toLocaleDateString()
      const finalValue = {Date: simpleDate, App:domain, Count: inpValue.y, x:inpValue.x, y:inpValue.y};
      this.setState(({ value }) => ({ value: { ...value, [domain]: finalValue } }))
      // console.log('onNearestXYCall', this.state.value);
    }
  
    render() {
      const { callDetailsData } = this.props;
      const { classes } = this.props;
      const colorArray = ['#92A8D1','#6B5B95','#88B04B','#FF6F61','#F7CAC9','#955251','#B565A7'];
      // console.log("render", callDetailsData);
      let data = [];
      if(callDetailsData.length>0){
        data = callDetailsData[0].data;
      }

      return (
        <div>
        <label><h3>Call Attempts</h3></label>
        <XYPlot xType="time" width={800} height={400} margin={{left: 100, bottom: 100, right:100}}
        onMouseLeave={() => {this.setState({ value: false})}}>
        <HorizontalGridLines />
        <VerticalGridLines />
        <XAxis style={{
            text: {stroke: 'none', fill: '#6b6b76', fontSize: '14px', fontWeight: '600'}
          }} 
          tickFormat={function tickFormat(d){
            const date = new Date(d);
            const dispDate = date.toISOString().substr(5,2) + '/' + date.toISOString().substr(8,2);
            return dispDate
           }} 
           tickTotal={7}/>
        <YAxis style={{
            text: {stroke: 'none', fill: '#6b6b76', fontSize: '14px', fontWeight: '600'}
          }}/>
        <ChartLabel 
          text="Time"
          includeMargin={true}
          xPercent={0.55}
          yPercent={0.63}
          style={{
            textAnchor: 'middle'
          }}
          />
  
        <ChartLabel 
          text="Count"
          includeMargin={true}
          xPercent={0.07}
          yPercent={0.1}
          style={{
            transform: 'rotate(-90)',
            textAnchor: 'middle'
          }}
          />
          {
            callDetailsData.map((callData, index) => {  
              const { domain, data } = callData;
              const hint = this.state.value[domain];
              // console.log({ domain, data, hint });
  
              return [
                <LineMarkSeries key={"LineMarkSeries"+index}
                  className="linemark-series-example"
                  style={{
                    strokeWidth: '3px'
                  }}
                  lineStyle={{stroke: colorArray[index]}}
                  markStyle={{stroke: colorArray[index]}}
                  // data={[{x: 1, y: 10}, {x: 2, y: 5}, {x: 3, y: 15}]}
                  data = {data}
                  onMouseLeave={this.mouseLeaveCall}
                  onSeriesMouseOver={this.mouseOverCall}
                  onNearestXY={(value) => this.onNearestXYCall(domain, value)} 
                  // {...markSeriesProps}
                />,
                hint ?
                <Hint key={"Hint"+index} value={hint || {}} >
                {hint? 
                      <div style={{background: 'black', borderRadius: '25px', padding: '20px'}}>
                        <p>Date : {hint.Date}<br></br>App : {hint.App}<br></br>Count : {hint.Count}</p>
                      </div> 
                      : null}

                </Hint> : null
              ];
             }
            )       
          }
        </XYPlot>
        <> 
        {
          callDetailsData.map((callData, index) => {
            const { domain, data } = callData;
            // console.log(data[index].legend)
            return[
              <DiscreteColorLegend key= {"LegendAttempts"+index}
              width={180}
              items={[{title: data[index].legend, color: colorArray[index+1]}]}
            />
            ];
          })
        }
        </>
        </div>
      )
      
      }
  }

export default (withApollo(CallAttempts));
